import { render, staticRenderFns } from "./MentionsLegales.vue?vue&type=template&id=6e2eccc4&scoped=true"
import script from "./MentionsLegales.vue?vue&type=script&lang=js"
export * from "./MentionsLegales.vue?vue&type=script&lang=js"
import style0 from "./MentionsLegales.vue?vue&type=style&index=0&id=6e2eccc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2eccc4",
  null
  
)

export default component.exports